//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.SearchFilterTerm.js";
import "../no/ugmath.js";
let d=[[],[[[],"GetExcludeToggle",{R_:{excludeToggle:''}},0,0],[["excludeToggle"],"SetExcludeToggle",{},1,0],[["nBoundingBoxes","boundingBoxes"],"GetBoundingBoxes",{},0,0],[["boundingBoxes"],"SetBoundingBoxes",{},1,0],[[],"GetOperator",{R_:{boxZoneOperator:''}},0,0],[["boxZoneOperator"],"SetOperator",{},1,0]],[]];
SPLM.PDM.VolumeSearchFilterTerm = class extends SPLM.PDM.SearchFilterTerm{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.VolumeSearchFilterTerm";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.VolumeSearchFilterTerm.BoundingBox = class{
    constructor(bottomCorner,topCorner){
        this.bottomCorner=bottomCorner;this.topCorner=topCorner;}
    get Bottomcorner(){if(this.bottomCorner === undefined) this.bottomCorner = new SPLM.Point3d(); return this.bottomCorner}
    set Bottomcorner(val){this.bottomCorner = val}
    get Topcorner(){if(this.topCorner === undefined) this.topCorner = new SPLM.Point3d(); return this.topCorner}
    set Topcorner(val){this.topCorner = val}
};

SPLM.PDM.VolumeSearchFilterTerm.Operator = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside", "Intersects" : "Intersects", "InsideOrIntersects" : "InsideOrIntersects", "OutsideOrIntersects" : "OutsideOrIntersects"});

export default SPLM;